import { useMutation } from '@tanstack/react-query';
import type { VerifyLeadRequest, VerifyLeadResponse } from '@pms/shared';
import { verifyLead } from '../services/api/leads.api';

/**
 * Verify a pending lead's email OTP (B→C). Write-only, no cache to invalidate.
 * Consumers read `mutate`, `isPending`, `isError`, `error` to drive the OTP panel.
 */
export function useVerifyLead() {
  return useMutation<VerifyLeadResponse, unknown, VerifyLeadRequest>({
    mutationFn: verifyLead,
  });
}
